import { AbstractControl } from "@angular/forms";

export function NoWhiteSpaceValidator(control: AbstractControl) {
    let isValid = true;
    if (control.value && control.value.length > 0) {
      const isWhitespace = (control.value || '').trim().length === 0;
      isValid = !isWhitespace;
    }
    return isValid ? null : { 'whitespace': true };
}